'use strict';
var pricePublisherMixin = require('../modules/mixins/price_publisher.mixin');
var trackingUtils = require('../modules/utils/tracking.utils');

Odigeo.defineWidget('promotionalcodes', Odigeo.Widget.extend(pricePublisherMixin.extend({
    minimumPromoCodeLength: 2,
    modelClass: Odigeo.Model.extend({
        totalFlightPrice: 0,
        totalDiscount: 0,
        promocode: {},
        promoCodeListArray: null,
        promotionalCode: '',
        removal: false,
        step: '',

        init: function() {
            this.totalFlightPrice = parseFloat(this.widget.options.totalPrice);
            this.widget.options = Odigeo.parseOptions(this.widget.options);
        },

        url: function() {
            return Odigeo.Settings.getProperty('serviceUrlFormatter')('addproduct');
        },

        getDataRequestSettings: function() {
            return {
                type: 'POST',
                contentType: 'application/json',
                dataType: 'html',
                cache: false,
                data: JSON.stringify({
                    bookingId: this.widget.options.bookingId,
                    promotionalCodes: [{
                        code: this.promotionalCode,
                    }],
                    nextPage: this.step,
                    removal: this.removal,
                }),
                success: Odigeo._.bind(this.requestSuccessHandler, this),
                error: Odigeo._.bind(this.requestErrorHandler, this),
            };
        },

        requestSuccessHandler: function(msg) {
            var response = Odigeo.Utils.parseJson(msg);
            this.promoCodeListArray = response.promoCodeList || {};
            this.widget.fillPromocodesList();

            if (response.errors === null) {
                this.widget.responseIsOK(this.removal ? 'coupon_remove_clicks' : 'coupon_ok');
                if (this.totalDiscount > this.totalFlightPrice) {
                    trackingUtils.trackEvent('coupon_section', 'coupon_maximum_discount_error');
                }
            } else {
                this.widget.responseIsKO(response.errors[0].code);
            }
        },

        requestErrorHandler: function() {
            this.widget.responseIsKO();
        },
    }),

    viewClass: Odigeo.View.extend({
        events: {
            'change @promoCodesCheck': 'onPromoCodesCheckChanged',
            'focus @promotionalCodeInput': 'onFocusInput',
            'blur @promotionalCodeInput': 'onBlurFocusInput',
        },

        selectors: {
            promotionalcodesBlockCheck: '.promotionalcodes_block_check',
            promoCodeButton: '.promo_code_button',
            codeKo: '.code_ko',
            codeKoMessage: '.code_ko_message',
            disclaimer: '.disclaimer',
            promotionalcodesBlockDiscounts: '.promotionalcodes_block_discounts',
            codeOk: '.code_ok',
            addCode: '.add_code',
            codeTotalDiscount: '.code_total_discount',
            promotionalcodesInfoBlock: '.promotionalcodes_info_block',
            promoCodesCheck: '#promoCodesCheck',
            promotionalCodeInput: 'input[name="promotionalCode"]',
            promoCodesTemplate: '.promo_codes_template',
            cobaltPromoCode: '.cobalt_promo_code',
        },

        init: function() {
            this.bindToDom();
        },

        bindToDom: function() {
            if (!this.isDomBinded) {
                this.$cachedSelectors.promotionalCodeInput.on(Odigeo.Events.keyup, Odigeo._.bind(function(evt) {
                    if (evt.keyCode === Odigeo.Events.keys.KEY_RETURN) {
                        this.checkHandler.call(this, this.$cachedSelectors.promotionalCodeInput.val(), false);
                    }
                }, this.widget));
                this.$cachedSelectors.promoCodeButton.on(Odigeo.Events.tap, Odigeo._.bind(function() {
                    this.widget.checkHandler.call(this.widget, this.$cachedSelectors.promotionalCodeInput.val(), false);
                    this.changePromoCodesFocus(true);
                }, this));
                this.$widget.on(Odigeo.Events.tap, '.cancel_code', Odigeo._.bind(this.widget.deleteHandler, this.widget, _));
                this.$cachedSelectors.addCode.on(Odigeo.Events.tap, Odigeo._.bind(this.showAddCodeSection, this));
                this.collapsibleContainer = Odigeo.UIElements.collapsive.enhance(this.$cachedSelectors.promotionalcodesInfoBlock, {
                    initiallyExpanded: this.widget.options.initiallyExpanded || this.widget.options.step === 'PRODUCT_PAGE',
                });

                if (this.widget.options.initiallyExpanded) {
                    this.addInitiallyExpandedSettings();
                }

                this.isDomBinded = true;
            }
        },

        addInitiallyExpandedSettings: function() {
            this.$cachedSelectors.promoCodesCheck.prop('checked', true);
            this.model.promoCodeListArray = Odigeo._.isObject(this.widget.options.promoCodeList) ? this.widget.options.promoCodeList.list : [];
            if (Odigeo._.size(this.model.promoCodeListArray)) {
                this.$cachedSelectors.promotionalcodesBlockCheck.addClass('odf-hidden');
            }
            this.widget.fillPromocodesList();
        },

        unbindFromDom: function() {
            if (this.isDomBinded) {
                this.$cachedSelectors.promoCodeButton.off(Odigeo.Events.tap);
                this.$cachedSelectors.promotionalCodeInput.off(Odigeo.Events.keyup);
                this.$cachedSelectors.cancelCodeDialog.off(Odigeo.Events.tap);
                this.$cachedSelectors.addCode.off(Odigeo.Events.tap);
                this.$cachedSelectors.promoCodesCheck.off(Odigeo.Events.change);
                this.isDomBinded = false;
            }
        },

        changePromoCodesFocus: function(toggle) {
            this.$cachedSelectors.promotionalCodeInput.closest('.paymentmanager_row').toggleClass('focused', toggle);
            if (Odigeo.AB.isCobaltDesktopForms) {
                this.$cachedSelectors.promotionalCodeInput.closest('.prisma-input-group').toggleClass('focused', toggle);
            }
        },

        onPromoCodesCheckChanged: function() {
            var isChecked = this.$cachedSelectors.promoCodesCheck.is(':checked');
            trackingUtils.trackEvent('coupon_section', isChecked ? 'show_coupon_click' : 'hide_coupon_click');
            this.collapsibleContainer.trigger('togglePanelByParameter', isChecked);
            this.hideCodeKODisclaimer();
        },

        hideCodeKODisclaimer() {
            if (this.$cachedSelectors.promoCodesCheck.is(':checked')) {
                this.$cachedSelectors.codeKo.addClass('odf-hidden');
            }
        },

        onFocusInput: function(el) {
            this.changeFocusInput(el, true);
        },

        onBlurFocusInput: function(el) {
            this.changeFocusInput(el, false);
        },

        changeFocusInput: function(el, add) {
            $(el.target).closest('.paymentmanager_row').toggleClass('focused', add);
            if (Odigeo.AB.isCobaltDesktopForms) {
                $(el.target).closest('.prisma-input-group').toggleClass('focused', add);
            }
        },

        showAddCodeSection: function() {
            this.$cachedSelectors.addCode.addClass('odf-hidden');
            this.$cachedSelectors.promotionalcodesBlockCheck.removeClass('odf-hidden');
        },
    }),

    deleteHandler: function(evt) {
        var $el = $(evt.target);
        $el.parent().find('.cancel_waiting').removeClass('odf-hidden');
        $el.addClass('odf-hidden');
        this.checkHandler($el.data('code'), true);
    },

    checkHandler: function(promotionalCode, isRemovalNeeded) {
        if (promotionalCode.length >= this.minimumPromoCodeLength) {
            this.model.promotionalCode = promotionalCode;
            this.changeWidgetState(isRemovalNeeded ? 'cancel_waiting' : 'add_code_button_loading');
            this.model.step = this.options.step;
            this.model.removal = isRemovalNeeded;
            this.model.isEmptyData = false;
            this.model.refresh();
        }
    },

    fillPromocodesList: function() {
        this.model.totalDiscount = 0;
        this.changeWidgetState('OK');

        if (Odigeo._.isArray(this.model.promoCodeListArray) && this.model.promoCodeListArray.length > 0) {
            var strSuccess = this.options.STR_success.split('[codename]');
            var tmpl = Odigeo._.template(this.view.$cachedSelectors.promoCodesTemplate.html(), Odigeo.Utils.getTmplSettings({variable: ''}));
            var templateList = Odigeo._.map(this.model.promoCodeListArray, function(iter) {
                this.model.totalDiscount += iter.discount;

                return tmpl({
                    code: iter.code,
                    discount: Odigeo.Utils.formatCurrency(parseFloat(iter.discount)),
                    promotionalCodeText: strSuccess[0],
                    promotionalCodeEndText: strSuccess[1],
                });
            }, this);
        }
        this.view.$cachedSelectors.codeOk.html(Odigeo._.isArray(templateList) ? templateList.join('') : '');
        this.view.$cachedSelectors.codeTotalDiscount.html(Odigeo.Utils.formatCurrency(parseFloat(this.model.totalDiscount)));

        var totalDiscount = -Math.abs(this.model.totalDiscount);
        this.model.set('promocode', {
            onePrice: totalDiscount,
            conceptLabel: this.options.pbdText,
            quantity: 1,
            allPrice: totalDiscount,
            type: 'PROMO_CODE',
        });
        this.changeWidgetState(this.model.totalDiscount > 0 ? 'showresults' : 'hideresults');
    },

    changeWidgetState: function(state) {
        // clean state
        if ( Odigeo.AB.isCobaltSidebarDesktop ) {
            this.view.$cachedSelectors.promoCodeButton.removeClass('loaded');
        }
        // apply new state
        switch (state) {
            case 'OK':
                this.view.$cachedSelectors.codeKo.addClass('odf-hidden');
                this.view.$cachedSelectors.promotionalCodeInput.removeClass('error');
                this.view.$cachedSelectors.disclaimer.addClass('odf-hidden');
                this.view.$cachedSelectors.promotionalCodeInput.val('');
                this.view.$cachedSelectors.codeOk.html('');
                this.view.$cachedSelectors.promoCodesCheck.prop('disabled', true);
                this.view.$cachedSelectors.promoCodeButton.removeClass('odf-hidden loading');
                this.view.$cachedSelectors.promotionalcodesBlockDiscounts.removeClass('odf-hidden');
                this.view.$cachedSelectors.addCode.removeClass('odf-hidden');

                if ( Odigeo.AB.isCobaltSidebarDesktop ) {
                    this.view.$cachedSelectors.promoCodeButton.addClass('loaded');
                }
                break;
            case 'KO':
                this.view.$cachedSelectors.codeKo.removeClass('odf-hidden');
                this.view.$cachedSelectors.promotionalCodeInput.addClass('error');
                this.view.$cachedSelectors.disclaimer.addClass('odf-hidden');
                this.view.$cachedSelectors.promotionalCodeInput.val('');
                this.view.$cachedSelectors.promotionalcodesBlockCheck.removeClass('odf-hidden');
                this.view.$cachedSelectors.promoCodeButton.removeClass('odf-hidden loading');
                this.view.changePromoCodesFocus(false);
                if (Odigeo._.size(this.model.promoCodeListArray) === 0) {
                    this.view.$cachedSelectors.promotionalcodesBlockDiscounts.addClass('odf-hidden');
                }
                this.view.$cachedSelectors.addCode.addClass('odf-hidden');
                break;
            case 'add_code_button_loading':
                this.view.$cachedSelectors.promoCodeButton.addClass('loading');
                break;
            case 'cancel_waiting':
                this.view.$cachedSelectors.promoCodeButton.removeClass('loading');
                break;
            case 'showresults':
                this.view.$cachedSelectors.promotionalcodesBlockCheck.addClass('odf-hidden');
                this.view.$cachedSelectors.promotionalcodesBlockDiscounts.removeClass('odf-hidden');
                this.view.$cachedSelectors.promoCodesCheck.prop('disabled', true);
                break;
            case 'hideresults':
                this.view.$cachedSelectors.promotionalcodesBlockCheck.removeClass('odf-hidden');
                this.view.$cachedSelectors.promotionalcodesBlockDiscounts.addClass('odf-hidden');
                this.view.$cachedSelectors.promoCodesCheck.removeAttr('disabled');
                break;
        }
    },

    responseIsOK: function(action) {
        var promocode = this.model.get('promocode');
        pricePublisherMixin.mixin.addItemToPricemanagerCollection(Odigeo._.extend(promocode, this.getAllPromocodesPrice()));
        Odigeo.trigger(this.id + ':updatePrices');
        Odigeo.trigger(this.id + ':updatePromocode', promocode);
        trackingUtils.trackEvent('coupon_section', action);
    },

    getAllPromocodesPrice: function() {
        return Odigeo._.reduce(this.model.promoCodeListArray, function(memo, actual) {
            return {
                allPrice: memo.allPrice - actual.discount,
                quantity: memo.quantity + 1,
            };
        }, {
            allPrice: 0,
            quantity: 0,
        });
    },

    responseIsKO: function(errorMessage) {
        var errorStr = (errorMessage === 'WNG_007') ?
            this.options['error_' + errorMessage].replace('[codename]', '"' + this.model.promotionalCode + '"') :
            this.options['error_' + errorMessage];
        this.changeWidgetState('KO');

        this.view.$cachedSelectors.codeKoMessage.text(errorStr);
        trackingUtils.trackEvent('coupon_section', 'coupon_not_ok_error');

        if (Odigeo.AB.isCobaltDesktopForms) {
            this.view.$cachedSelectors.cobaltPromoCode.attr('data-state', 'empty');
        }
    },

})));
